import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ViewComponent} from './view/view.component';
import { CreateComponent } from './create/create.component';
import { EditComponent } from './edit/edit.component';


const routes: Routes = [
	{
		path: '',
		component:ViewComponent
	},
	{
		path:'create',
		component:CreateComponent
	},
	{
		path:':id/edit',
		component: EditComponent
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestimonialRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/platform/testimonial/testimonial-routing.module.ts